// src/services/config.ts
/**
 * Configuration utility for environment-specific settings
 * This centralizes access to environment variables and provides
 * environment detection helpers
 */

export interface AppConfig {
  apiUrl: string;
  environment: string;
  isProduction: boolean;
  isStaging: boolean;
  isDevelopment: boolean;
  version: string;
}

/**
 * Get the current application configuration based on environment
 * @returns AppConfig object with environment-specific settings
 */
export const getConfig = (): AppConfig => {
  const env = process.env.REACT_APP_ENV || 'development';
  
  const config: AppConfig = {
    apiUrl: process.env.REACT_APP_API_URL || '',
    environment: env,
    isProduction: env === 'production',
    isStaging: env === 'staging',
    isDevelopment: env === 'development',
    version: process.env.REACT_APP_VERSION || '0.1.0'
  };
  
  return config;
};

// Export a singleton instance for easy imports
export const config = getConfig();

// Export environment check helpers
export const isProd = (): boolean => config.isProduction;
export const isStaging = (): boolean => config.isStaging;
export const isDev = (): boolean => config.isDevelopment;